import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllExportSalesOrder = createAsyncThunk(
  "ExportSalesOrder/FindAllExportSalesOrder",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindAllExportSalesOrder`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getLatestPoNo = createAsyncThunk(
  "ExportSalesOrder/FindLatestpono",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ExportSalesOrder/FindLatestpono`
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error getting Po. No.:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createExportSalesOrder = createAsyncThunk(
  "ExportSalesOrder/InsertExportSalesOrder",
  async (Item: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/InsertExportSalesOrder`,
        Item
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const createSingleExportSalesOrder = createAsyncThunk(
  "ExportSalesOrder/SingleInsertExportSalesOrder",
  async (Item: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/SingleInsertExportSalesOrder`,
        Item
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Single Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateExportSalesOrder = createAsyncThunk(
  "ExportSalesOrder/UpdateExportSalesOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/UpdateExportSalesOrder`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error update Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getExportSalesOrderByID = createAsyncThunk(
  "ExportSalesOrder/FindByIDExportSalesOrder",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindByIDExportSalesOrder`,
        { id: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        pono: result?.pono,
        po_date: result?.po_date
          ? moment(result?.po_date, "YYYY-MM-DD").toDate()
          : "",
        party_id: result?.party_id,
        remarks: result?.remarks,
        export_sales_order_guid: result?.export_sales_order_guid,
        vendor_options: result?.vendor_options || [],
        exp_delivery_date: result?.exp_delivery_date
          ? moment(result?.exp_delivery_date, "YYYY-MM-DD").toDate()
          : "",
        export_sales_order_groupwise: result?.export_sales_order_groupwise,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getExportSalesOrderListByID = createAsyncThunk(
  "ExportSalesOrder/FindByIDExportSalesOrderList",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindByIDExportSalesOrder`,
        { id: ID }
      );
      const result = response.data?.Data as any;
      return {
        export_sales_order_groupwise:
          result?.export_sales_order_groupwise || [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteExportSalesOrder = createAsyncThunk(
  "ExportSalesOrder/DeleteExportSalesOrder",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/DeleteExportSalesOrder`,
        { id: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const deleteExportSalesOrderItem = createAsyncThunk(
  "ExportSalesOrder/DeleteExportSalesOrderItems",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/DeleteExportSalesOrderItems`,
        { id: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Export Sales Order items:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getExportSalesOrderByPONO = createAsyncThunk(
  "ExportSalesOrder/FindByPonoExportSalesOrder",
  async (pono: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindByPonoExportSalesOrder`,
        { pono: pono }
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        pono: result?.pono,
        po_date: result?.po_date,
        party_id: result?.party_id,
        party_name: result?.party_name,
        export_sales_order_guid: result?.export_sales_order_guid,
        exp_delivery_date: result?.exp_delivery_date
          ? moment(result?.exp_delivery_date, "YYYY-MM-DD").toDate()
          : "",
        export_sales_order_pending: result?.export_sales_order_pending || [],
        export_sales_order_packing_list:
          result?.export_sales_order_packing_list || [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Export Sales Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getExportSalesOrderPrint = createAsyncThunk(
  "ExportSalesOrder/FindBYExportSalesOrderPrint",
  async (GUID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportSalesOrder/FindBYExportSalesOrderPrint`,
        { export_sales_order_guid: GUID }
      );
      return response.data?.Data as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Export Sales Order Print Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
